export var isServer = function () { return typeof window === 'undefined'; };
//# sourceMappingURL=utils.js.map